import React, { useEffect } from 'react';
import styled from 'styled-components';
import ShapeProgress from './ShapeProgress';
import QuestionPublicLink from '../../PublicLink/PublicLink';
import { QuizScreen } from '../../../types/GeneralStyles';
import { NavigationButtons, NavigationButton } from '../../../QuizOverview';
import { getFromDB, deleteFromDB } from '../../indexedDB/indexedDB'; // Import delete function

const ItemContainer = styled.div`
  .item-container {
    /* Add any specific styles if needed */
  }
`;

const QuizShape = ({
  shape,
  index,
  quiz,
  quizProgress,
  overViewPage,
  setQuizProgress,
  handleEnableNavigation,
  enableNavigationButton,
  renderComponent,
}) => {
  useEffect(() => {
    const cleanIndexedDB = async () => {
      const dbName = sessionStorage.getItem("currentSessionName") || "Leerling";
      // console.log("test",shape);
      try {
        const storedData = await getFromDB(dbName);
        const quizIdsToRemove = shape.ori_quiz_shape_order?.map(order => order.quiz_item_id) || [];
        
        for (const id of quizIdsToRemove) {
          if (storedData.some(item => item.id === id)) {
            await deleteFromDB(dbName, id);
            console.info(`Removed quiz ID ${id} from IndexedDB.`);
          }
        }
      } catch (error) {
        console.error("Error while cleaning IndexedDB:", error);
      }
    };
    
    cleanIndexedDB();
  }, [shape.quiz_shape_order]);

  const shapeLength = shape.quiz_shape_order_combined.length;
  const currentShapeProgress = quizProgress[index]?.currentIndex || 0;
  const progress =
    shapeLength > 1
      ? (currentShapeProgress / (shapeLength - 1)) * 100
      : 100;

  const handlePrevious = () => {
    setQuizProgress((prevState) =>
      prevState.map((s, i) =>
        i === index
          ? {
              ...s,
              currentIndex: s.currentIndex > 0 ? s.currentIndex - 1 : 0,
            }
          : s
      )
    );
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const handleNext = () => {
    handleEnableNavigation();
    setQuizProgress((prevState) =>
      prevState.map((s, i) =>
        i === index
          ? {
              ...s,
              currentIndex:
                s.currentIndex < shapeLength - 1
                  ? s.currentIndex + 1
                  : s.currentIndex,
            }
          : s
      )
    );
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <QuizScreen
      bgColor={shape.theme_color}
      bgVisible={overViewPage}
      id={shape.quiz_shape_id}
      key={shape.id}
    >
      <QuestionPublicLink
        overViewPage={overViewPage}
        type="shape"
        quiz_item_id={shape.quiz_shape_id}
      />
      <ShapeProgress bgColor={shape.theme_color} progress={progress} />

      <ItemContainer className="item-container">
        {shape.quiz_shape_order_combined[currentShapeProgress]?.data &&
          renderComponent(
            shape.quiz_shape_order_combined[currentShapeProgress].data,
            currentShapeProgress,
            quiz,
            enableNavigationButton
          )}
      </ItemContainer>

      <NavigationButtons className="navigation-buttons">
        <NavigationButton
          onClick={handlePrevious}
          bgColor={shape.theme_color}
          canBeClicked={currentShapeProgress === 0}
          disabled={!enableNavigationButton}
        >
          {shape.quiz_shape_order_combined[currentShapeProgress]?.custom_prev_text ?? shape.prev_text}
        </NavigationButton>
        <NavigationButton
          onClick={handleNext}
          bgColor={shape.theme_color}
          canBeClicked={currentShapeProgress === shapeLength - 1}
          disabled={!enableNavigationButton}
        >
          {shape.quiz_shape_order_combined[currentShapeProgress]?.custom_next_text ?? shape.next_text}
        </NavigationButton>
      </NavigationButtons>
    </QuizScreen>
  );
};

export default QuizShape;
